<template>
  <div class="formTextArea">
    <label class="formTextArea__label" :for="name">
      <textarea
        :id="name"
        :name="name"
        :value="value"
        :class="['formTextArea__input', { 'formTextArea__input--withUploader': withUploader }]"
        :disabled="disabled"
        @input="onInput"
        @change="$emit('change')"
      />
      <span class="formTextArea__labelText">
        {{ label }}
      </span>
    </label>
    <div v-if="withUploader" class="formTextArea__uploader">
      <slot name="uploader" />
    </div>
    <slot name="error" />
  </div>
</template>

<script>
export default {
  name: 'FormTextArea',
  props: {
    name: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    withUploader: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value);
      this.$emit('emitObject', { name: this.name, value: e.target.value });
    },
  },
};
</script>

<style lang="scss">
.formTextArea {
  $root: &;
  position: relative;
  padding-top: 1.5rem;

  &.is-invalid {
    #{$root}__input {
      border: 2px solid $cBadgeProm;

      &--withUploader {
        border-bottom: 1px solid $cAddLight;
      }
    }

    #{$root}__uploader {
      border-left: 2px solid $cBadgeProm;
      border-right: 2px solid $cBadgeProm;
      border-bottom: 2px solid $cBadgeProm;
    }
  }

  &__input {
    display: block;
    position: relative;
    border: 1px solid $cAddLight;
    border-radius: 4px;
    color: $cMainLight;
    font-size: 1.4rem;
    height: 17.5rem;
    width: 100%;
    padding: 1.6rem 2rem;
    transition: border $tr;
    resize: none;
    transform: translateZ(0);

    &--withUploader {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    &::placeholder {
      color: $cAddDark02;
    }

    &:active:not(:disabled) ~ #{$root}__labelText,
    &:focus:not(:disabled) ~ #{$root}__labelText {
      top: 0;
    }

    &:disabled {
      background-color: $cBg;

      & ~ #{$root}__labelText {
        background-color: transparent;
      }
    }
  }

  &__label {
    display: block;
    position: relative;
  }

  &__labelText {
    white-space: nowrap;
    overflow: hidden;
    max-width: calc(100% - 2rem);
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 600;
    color: $cMainDark;
    background-color: $cWhite;
    margin-left: 1rem;
    padding: 0 1rem;
    position: absolute;
    top: 0;
    transform: translate(0, -50%);
    left: 0;
    z-index: 10;
    transition: top $trM;
    pointer-events: none;
  }

  &__error {
    display: inline-block;
    color: $cBadgeProm;
    font-size: 1.4rem;
    line-height: 1.6rem;
    transition: color $tr, margin $tr;
    margin: 0.3rem 0 0.4rem 0;
  }

  &__uploader {
    padding: 1.5rem 2rem;
    border: 1px solid $cAddLight;
    border-top: none;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    position: relative;
    top: -1px;
    transition: border $tr;
  }
}
</style>
